const STATUS_STYLES = {
  paid: { c: "text-gold border-gold/40 bg-gold/10", l: "Pagada" },
  confirmed: { c: "text-cyan border-cyan/40 bg-cyan/10", l: "Confirmada" },
  cancelled: { c: "text-neutral-500 border-neutral-700 bg-neutral-900", l: "Cancelada" },
  pending: { c: "text-neonpink border-neonpink/40 bg-neonpink/10", l: "Pendiente" },
};

export default function StatusBadge({ status }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.pending;
  return (
    <span
      data-testid={`badge-${status}`}
      className={`text-[10px] uppercase tracking-widest px-2 py-1 rounded-full border shrink-0 ${s.c}`}
    >
      {s.l}
    </span>
  );
}

export const STATUS_LABELS = Object.fromEntries(
  Object.entries(STATUS_STYLES).map(([k, v]) => [k, v.l])
);
